module.exports = __webpack_public_path__ + "12_hair_black.2e840ce2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/12_hair_black.png
// module id = X/NW
// module chunks = 0